export default __webpack_public_path__ + "static/media/paleta.d4d107e3.png";